import { parseDentallyDate } from './dentallyUtils';

const getId = (value) => value?.id ?? value;

const sameId = (left, right) => (
  left != null && right != null && String(getId(left)) === String(getId(right))
);

const toMillis = (value) => parseDentallyDate(value)?.getTime() ?? null;

export const flattenLeadAppointments = (lead) => {
  const seen = new Set();
  return (Array.isArray(lead?.lead_treatments) ? lead.lead_treatments : [])
    .flatMap((leadTreatment) => (
      (Array.isArray(leadTreatment?.appointments) ? leadTreatment.appointments : [])
        .map((appointment) => ({
          ...appointment,
          lead_treatment: appointment?.lead_treatment ?? leadTreatment.id,
        }))
    ))
    .filter((appointment) => {
      if (appointment?.id == null || seen.has(String(appointment.id))) return false;
      seen.add(String(appointment.id));
      return true;
    });
};

export const resolveDentallyBookingAppointment = ({ lead, fingerprint }) => {
  if (!lead || !fingerprint || !fingerprint.startTime) {
    return { outcome: 'none', appointment: null, matches: [] };
  }

  if (fingerprint.leadId != null && lead.id != null && !sameId(lead.id, fingerprint.leadId)) {
    return { outcome: 'none', appointment: null, matches: [] };
  }

  const leadPracticeId = getId(lead.practice ?? lead.practice_id);
  if (fingerprint.practiceId != null && leadPracticeId != null
      && !sameId(leadPracticeId, fingerprint.practiceId)) {
    return { outcome: 'none', appointment: null, matches: [] };
  }

  const expectedStart = toMillis(fingerprint.startTime);
  if (expectedStart == null) return { outcome: 'none', appointment: null, matches: [] };

  const expectedFinish = toMillis(fingerprint.finishTime);
  const matches = flattenLeadAppointments(lead).filter((appointment) => {
    if (appointment?.status === 'CANCELLED') return false;
    if (toMillis(appointment?.datetime ?? appointment?.start_time) !== expectedStart) return false;

    if (fingerprint.treatmentId != null
        && !sameId(appointment?.lead_treatment, fingerprint.treatmentId)) return false;

    const appointmentFinish = appointment?.finish_time ?? appointment?.finishTime;
    if (expectedFinish != null && appointmentFinish != null
        && toMillis(appointmentFinish) !== expectedFinish) return false;

    return true;
  });

  if (matches.length === 1) return { outcome: 'unique', appointment: matches[0], matches };
  if (matches.length > 1) return { outcome: 'ambiguous', appointment: null, matches };
  return { outcome: 'none', appointment: null, matches };
};
